// AUTO-GENERATED - DO NOT EDIT MANUALLY
// Generated from App\Controller\Dto\Response\AdminBookingListItemResponse

import { BookingStatus, BookingOrigin } from './enums.gen';
import { hydrateAdminBusinessReference, type AdminBusinessReference, type AdminBusinessReferenceApiResponse } from './adminBusinessReference.gen';
import { hydrateAdminBookingCustomer, type AdminBookingCustomer, type AdminBookingCustomerApiResponse } from './adminBookingCustomer.gen';
import { DateTimefromYmd, DateTimefromISO } from '#lib/helper/date.js';
import type { DateTime } from 'luxon';

export type AdminBookingListItemApiResponse = {
	id: string;
	business: AdminBusinessReferenceApiResponse;
	date: string;
	pax: number;
	status: BookingStatus;
	createdAt: string;
	updatedAt: string;
	origin: BookingOrigin;
	startTime: string | null;
	customer: AdminBookingCustomerApiResponse | null;
	offerName: string | null;
};

export type AdminBookingListItem = {
	id: string;
	business: AdminBusinessReference;
	date: DateTime;
	pax: number;
	status: BookingStatus;
	createdAt: DateTime;
	updatedAt: DateTime;
	origin: BookingOrigin;
	startTime: string | null;
	customer: AdminBookingCustomer | null;
	offerName: string | null;
};

export function hydrateAdminBookingListItem(data: AdminBookingListItemApiResponse): AdminBookingListItem {
	return {
		...data,
		business: hydrateAdminBusinessReference(data.business),
		date: DateTimefromYmd(data.date)!,
		createdAt: DateTimefromISO(data.createdAt)!,
		updatedAt: DateTimefromISO(data.updatedAt)!,
		customer: data.customer ? hydrateAdminBookingCustomer(data.customer) : null,
	};
}